import { ServiceArtistModel } from "."

export enum StreamingInterval {
  monthly = 'monthly',
  weekly = 'weekly',
  daily = 'daily'
}

export type Audience = ServiceArtistModel & {
  gender: Record<string, number>,
  age: Record<string, number>
}